import { DataTable } from './../../interfaces/datatable.interface';
import { Component, Input, OnInit, EventEmitter, Output, HostListener } from '@angular/core';

@Component({
  selector: 'app-datatable-paginacion-limit',
  templateUrl: './datatable-paginacion-limit.component.html',
  styleUrls: ['./datatable-paginacion-limit.component.scss']
})
export class DatatablePaginacionLimitComponent implements OnInit {

  MOBILE_WIDTH = 450;
  innerWidth: number;

  @Input() datatable: DataTable;
  @Input() size = 20;
  @Input() page = 1;
  @Input() total = 1;
  @Input() calculatingTotal: boolean = false;

  @Output() onPageCambiada = new EventEmitter<number>();
  @Output() onSizeCambiado = new EventEmitter<number>();

  constructor() { }

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
  }

  setPage(page: number) {
    if (page > 0) {
      this.page = page;
      this.onPageCambiada.emit(this.page);
    }
  }

  paginaCambiada() {
    this.onPageCambiada.emit(this.page);
  }

  sizeCambiado(size) {
    this.size = size;
    this.onSizeCambiado.emit(this.size);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  get isDesktop() {
    return this.innerWidth >= this.MOBILE_WIDTH;
  }

}
